import React from "react";

import styles from "../../../../styles/secrets-drawers.module.scss";
import { Drawer } from "../../../components/Drawer";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { IntegrationsAPI } from "../../../../providers/IntegrationsAPI";
import { Hairline } from "../../../components/Hairline";
import { Select } from "@components";

export default class OpenDeliveryDrawer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            active: true,
            clientId: null,
            clientSecret: null,
            apiUrl: null,
            merchantId: null,
            apiKey: null,
            merchantUrl: null,
            deliveredBy: null,
        };
    }

    async componentDidMount() {
        const openDeliveryResponse = await IntegrationsAPI.getOpenDeliveryCredentials(
            EnvironmentStorage.getSelectedEnvironment()
        );

        const openDelivery = openDeliveryResponse.getData({});

        this.setState({
            clientId: openDelivery?.client_id,
            clientSecret: openDelivery?.client_secret,
            apiUrl: openDelivery?.url,
            merchantId: openDelivery?.merchantId,
            merchantUrl: openDelivery?.merchantUrl,
            apiKey: openDelivery?.apiKey,
            deliveredBy: openDelivery?.deliveredBy,
        })
    }

    async updateMerchantId() {
        const { merchantId, merchantUrl, apiKey, deliveredBy } = this.state;

        this.setState({ loading: true });

        const updateResponse = await IntegrationsAPI.putOpenDeliveryCredentials(
            await EnvironmentStorage.getSelectedEnvironment(),
            { merchantId, merchantUrl, apiKey, deliveredBy }
        );

        if (updateResponse.getErrors([]).length > 0) {
            alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
            this.setState({ loading: false });
            return false;
        } else {
            alert({ text: "Dados salvos com sucesso", buttonText: "Ok" });
        }

        this.setState({ loading: false });

        return true;
    }

    render() {
        const { loading, clientId, clientSecret, apiUrl, merchantId, merchantUrl, apiKey, deliveredBy } = this.state;
        const { visible, onClose } = this.props;

        return (
            <Drawer
                visible={visible}
                onClose={onClose}
                closeInFade
                title="Open Delivery"
            >
                <div className={styles.secretDrawerContainer}>
                    <div className={styles.container}>
                        <div className={styles.tokens}>
                            <p>CLIENT ID</p>
                            <div className={styles.code}>{clientId}</div>
                            <p>CLIENT SECRET</p>
                            <div className={styles.code}>{clientSecret}</div>
                            <p>Open Delivery URL</p>
                            <div className={styles.code}>{apiUrl}</div>
                        </div>
                        <Hairline />
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="Merchant Id (PDV)"
                            value={merchantId}
                            onChange={(e) => this.setState({ merchantId: e.target.value })}
                        />
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="Merchant URL"
                            value={merchantUrl}
                            onChange={(e) => this.setState({ merchantUrl: e.target.value })}
                        />
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="Chave de autenticação"
                            value={apiKey}
                            onChange={(e) => this.setState({ apiKey: e.target.value })}
                        />

                        <Select
                            design="two"
                            className="mb-20"
                            label="Tipo de entrega (deliveredBy)"
                            onChange={(e) => this.setState({ deliveredBy: e.target.value })}
                            value={deliveredBy || "MERCHANT"}
                            options={[
                                { label: "MERCHANT", value: "MERCHANT", selected: deliveredBy == "MERCHANT" },
                                { label: "MARKETPLACE", value: "MARKETPLACE", selected: deliveredBy == "MARKETPLACE" },
                            ]}
                        />
                    </div>
                    <div className={styles.footer}>
                        <Button
                            design="primary"
                            className="w-100"
                            onClick={() => this.updateMerchantId()}
                            loading={loading}
                            disabled={loading}
                        >
                            Salvar
                        </Button>
                    </div>
                </div>
            </Drawer>
        );
    }
}
